import { QueryClientProvider } from "@tanstack/react-query";
import type React from "react";

import type { AuthUser } from "~/auth";
import { LocaleContext } from "~/components/LocaleContext";
import { UserContext } from "~/components/UserContext";
import { useCreateQueryClient } from "~/hooks/query";
import type { Locale } from "~/i18n";

import { CreateMenu } from "./CreateMenu";
import { UserMenu } from "./UserMenu";

export const HeaderButtons: React.FC<{
  locale: Locale;
  user: AuthUser | null;
  children: React.ReactElement;
}> = ({ locale, user, children }) => {
  const queryClient = useCreateQueryClient();
  return (
    <UserContext value={user}>
      <QueryClientProvider client={queryClient}>
        <LocaleContext value={locale}>
          <div className="relative">
            {children}
            <div className="right-1 top-1 md:absolute">
              <CreateMenu />
            </div>
          </div>
          <UserMenu />
        </LocaleContext>
      </QueryClientProvider>
    </UserContext>
  );
};
